
import {Component, Prop, Vue} from 'vue-property-decorator';
import XDialog from '@/components/x-dialog/x-dialog.vue';
import XTable from '@/components/x-table/x-table.vue';
import {$xDialog} from '@/components/x-dialog/dialog.proxy';
import {$xTable, XTableProxy, XTableStdRequestParams, XTableStdResponse} from '@/components/x-table/table.proxy';
import * as API_goods from "@/api/goods";

@Component({
  name: 'dialog-change-price',
  components: {
    XDialog,
    XTable
  }
})
export default class DialogChangePrice extends Vue {
  @Prop() goods_id;
  @Prop() log_type;

  tableProxy: XTableProxy = null!;

  dialogProxy = $xDialog.create({
    title: '变更记录',
    wrapperClass: 'dialog-change-price',
    disableConfirm: true,
    disableCancel: true,
    showClose: true,
    width: '60vw',
  });

  showDialog(goodsId, logType) {
    this.dialogProxy.display();
    this.buildTableProxy(goodsId, logType);
  }

  buildTableProxy(goodsId, logType) {
    // if (this.tableProxy) {
    //   return this.tableProxy.reset();
    // }

    this.tableProxy = $xTable.create({
      key: 'id',
      search: {
        formData: () => {
          return {
            goods_id: goodsId,
            log_type: logType
          };
        },
      },
      onRequest(params: XTableStdRequestParams): Promise<XTableStdResponse> {
        return API_goods.getChange({
          page_no: params.pageIndex,
          page_size: params.pageSize,
          ...params.search
        })
      }
    });
  }
}

